<template>
  <v-container class="main-container">
    <v-row>
      <v-col cols="12">
        <v-card
          tile
          flat
          class="userBriefHistory pa-5"
          :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
        >
          <TitleBar></TitleBar>
          <AllTabs></AllTabs>
          
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AllTabs from "@/components/MarketingTool/AllTabs.vue";
import TitleBar from "@/components/MarketingTool/TitleBar.vue";
export default {
  components: {
    TitleBar,
    AllTabs,
  },
};
</script>
